import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import escape from '../utils/escape';
import classnames from 'classnames';

import ListItem from './ListItem';

require('./AutoTaskInput.less');

class AutoCustomerInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        let customers = this.props.customers;
        customers.sort((a, b) => a.name.localeCompare(b.name));

        this.state = {
            text: this.props.defaultText,
            selectedID: null,
            selectedName: null,
            selectedIndex: 0,
            scrollTop: 0,
            filteredCustomers: customers,
            customers: customers,
            focused: false,
            blurTimeout: null,
            disabled: this.props.disabled
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        this.setState({
            popupWidth: ReactDOM.findDOMNode(this.refs.companyField).offsetWidth,
            popupLeft: ReactDOM.findDOMNode(this.refs.companyField).offsetLeft,
            popupTop: ReactDOM.findDOMNode(this.refs.companyField).offsetHeight + ReactDOM.findDOMNode(this.refs.companyField).offsetTop - 1
        });
    }

    componentWillUnmount = () => {
        clearTimeout(this.state.blurTimeout);
    }

    // EVENT HANDLERS

    handleBlur = () => {
        this.setState({
            blurTimeout: setTimeout(() => {
                this.setState({
                    focused: false,
                    selectedIndex: 0,
                    forcePopup: false
                });
            }, 200)
        });
    }

    handleChange = (changeEvent) => {
        let text = changeEvent.target.value;

        this.setState({
            text: text,
            selectedID: null,
            selectedValue: null,
            selectedIndex: 0,
            scrollTop: 0,
            focused: true
        }, () => {
            this.filtercustomers(text);
        });

        if (this.props.handleTextChange) {
            this.props.handleTextChange();
        }
    }

    handleFocus = () => {
        this.setState({
            focused: true,
            selectedIndex: 0
        });

        this.filtercustomers(this.state.text);
    }

    handleKeyDown = (keyEvent) => {
        let newScrollTop = this.state.scrollTop;

        if (keyEvent.key === "Tab") {
            keyEvent.key = "Enter";
            this.handleKeyPress(keyEvent);
        } else if (keyEvent.key === "ArrowUp" && this.state.selectedIndex - 1 >= 0) {
            // calculate the new position by subtracing height of one item and then set it
            if (this.refs.popup) {
                ReactDOM.findDOMNode(newScrollTop = this.state.scrollTop - this.refs["item" + (this.state.selectedIndex - 1)]).scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            this.setState({
                selectedIndex: this.state.selectedIndex - 1,
                focused: true,
                scrollTop: newScrollTop
            });
        } else if (keyEvent.key === "ArrowDown" && this.state.selectedIndex + 1 < this.state.filteredCustomers.length) {
            // calculate the new position by adding height of one item but watching that it doesn't go over max height
            if (this.refs.popup) {
                ReactDOM.findDOMNode(newScrollTop = this.state.scrollTop + this.refs["item" + (this.state.selectedIndex + 1)]).scrollHeight;
                let popupDOMNode = ReactDOM.findDOMNode(this.refs.popup);
                if (newScrollTop > popupDOMNode.scrollHeight) newScrollTop = popupDOMNode.scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            // filter since we are gonna show the popup list
            let filter = new RegExp(escape.escapeInput(this.state.text), 'i');

            this.setState({
                selectedIndex: this.state.selectedIndex + 1,
                focused: true,
                scrollTop: newScrollTop,
                filteredCustomers: this.state.customers.filter(company => filter.test(company.name))
            });
        } else if (keyEvent.key === "Escape" && this.state.focused) {
            // don't close the create pill outside
            keyEvent.stopPropagation();

            this.setState({
                focused: false
            });
        }
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            // filter once again but this time trimmed
            this.filtercustomers(this.state.text.trim());

            if (this.state.filteredCustomers.length === 1) {
                // only one matches, set the state to that task and clear focus so the popup isn't annoying
                this.setState({
                    text: this.state.filteredCustomers[0].name,
                    selectedID: this.state.filteredCustomers[0].id,
                    selectedName: this.state.filteredCustomers[0].name,
                    selectedIndex: 0,
                    scrollTop: 0,
                    focused: false
                },
                this.handleMouseDown(0));
            } else if (this.state.filteredCustomers.length > 1) {
                this.setState({
                    text: this.state.filteredCustomers[this.state.selectedIndex].name,
                    selectedID: this.state.filteredCustomers[this.state.selectedIndex].id,
                    selectedName: this.state.filteredCustomers[this.state.selectedIndex].name,
                    selectedIndex: this.state.selectedIndex,
                    scrollTop: 0,
                    focused: false
                },
                this.handleMouseDown(this.state.selectedIndex));
            }

            keyEvent.stopPropagation();
        }
    }

    handleMouseDown = (selectedIndex) => {
        // called on left click
        let company = {
            ...this.state.filteredCustomers[selectedIndex]
        };

        this.props.handleFunction(company);

        setTimeout(() => {
            if (this.props.keepAfterClick) {
                let text = company.name;
                this.setState({
                    text: text
                });
            }
            else {
                    this.setState({
                    text: '',
                    selectedID: null,
                    selectedName: null,
                    selectedIndex: selectedIndex,
                    scrollTop: 0,
                    focused: false
                });
            }
        }, 150);
    }

    handleMouseOver = (selectedIndex) => {
        this.setState({
            selectedIndex: selectedIndex,
        });
    }

    handleScroll = () => {
        if (this.state.blurTimeout) {
            clearTimeout(this.state.blurTimeout);
            this.setState({
                blurTimeout: null
            });
            ReactDOM.findDOMNode(this.refs.companyField).focus();
        }
    }

    // OTHER METHODS

    clear = () => {
        this.setState({
            text: "",
            selectedID: null,
            selectedName: null,
            selectedIndex: 0,
            scrollTop: 0,
            filteredCustomers: this.state.customers,
            focused: false,
        }, () => {
            this.props.handleTextChange();
        });
    }

    filtercustomers (userInput) {
        if (userInput === '') {
            this.setState({
                filteredCustomers: this.state.customers
            });

            return;
        }

        let filter = new RegExp(escape.escapeInput(userInput), 'i');

        // delay set so it's not annoyingly fast and changing instantly at every character
        setTimeout(() => {
            this.setState({
                filteredCustomers: this.state.customers.filter(customer => filter.test(customer.name))
            });
        }, 300);
    }

    getSelectedId = () => {
        return this.state.selectedID;
    }

    getSelectedName = () => {
        return this.state.selectedName;
    }

    // RENDER METHOD

    render = () => {
        return (
            <span>
                <label>
                    {this.props.label}
                </label>
                <input
                    style={{display: "inline"}}
                    type="input"
                    ref="companyField"
                    className="form-control"
                    value={this.state.text ? this.state.text : ""}
                    placeholder={this.props.placeholder}
                    onKeyDown={this.handleKeyDown}
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    disabled={this.state.disabled ? this.state.disabled : false}
                    />
                   {
                        this.props.enableClear && this.state.text ?
                        <a style={{"cursor" : "pointer", "paddingRight" : "20px", "marginTop" : "5px"}} onClick={this.clear} className="filter-clear"><span><span className="md-clear"></span></span></a>
                        : null
                    }
                {
                    this.state.focused && this.state.filteredCustomers.length > 0
                    ?
                        (
                            <ul className="popup" onScroll={this.handleScroll} style={{ "width": this.state.popupWidth + "px", "top": this.state.popupTop + "px", "left": this.state.popupLeft + "px" }} ref="popup" onClick={this.handleClick}>
                                {
                                    this.state.filteredCustomers.map((company, i) => {
                                        let classNames = classnames({
                                            'popup-text': i != this.state.selectedIndex,
                                            'popup-text-selected': i === this.state.selectedIndex
                                        });

                                        return <ListItem
                                                    ref={"item" + i}
                                                    classNames={classNames}
                                                    key={company.id}
                                                    id={company.id}
                                                    index={i}
                                                    mouseDown={this.handleMouseDown}
                                                    mouseOver={this.handleMouseOver}
                                                    name={company.name}
                                                    />;
                                    })
                                }
                            </ul>
                        )
                    : null
                }
            </span>
        );
    }
}

AutoCustomerInput.propTypes = {
    customers: PropTypes.array,
    defaultText: PropTypes.string,
    enableClear: PropTypes.bool,
    handleFunction: PropTypes.func,
    handleTextChange: PropTypes.func,
    keepAfterClick: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool
};

AutoCustomerInput.defaultProps = {
    defaultText: ""
};

const mapStateToProps = (state) => {
    return {
        customers: state.customers.customers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutoCustomerInput);



/** WEBPACK FOOTER **
 ** ./src/app/components/AutoCustomerInput.js
 **/